export default __webpack_public_path__ + "static/media/KuttiImage.93f280b8.svg";